// Environment + device detection helpers.

/// <reference types="vite/client" />

declare global {
  interface ImportMetaEnv {
    readonly VITE_API_BASE?: string;
  }
  interface ImportMeta {
    readonly env: ImportMetaEnv;
  }
}

/** Base URL of the DeckMachine backend. Defaults to localhost for dev. */
export const API_BASE: string =
  import.meta.env.VITE_API_BASE ?? "http://localhost:3000";

/**
 * iOS detection for AR Quick Look gating.
 *
 * AR Quick Look is only available on iOS Safari (including in-app Safari
 * WebViews like Messages and Mail). We deliberately do NOT enable it on:
 *   - iPadOS in desktop mode (UA spoofs as macOS) — model-viewer fallback
 *     still works and there's no reliable way to detect this
 *   - Android Chrome (uses Scene Viewer via model-viewer's `ar` attribute)
 *   - Desktop browsers
 *
 * `MSStream` is a legacy IE/Edge artifact that historically false-positived on
 * the iPhone regex; the guard is cheap and well-established.
 *
 * We additionally check for the Safari engine via `AppleWebKit` AND the
 * absence of `CriOS`/`FxiOS` (Chrome/Firefox on iOS, which embed WebKit but
 * route AR Quick Look correctly via the same anchor — so we keep them in).
 * In practice every iOS browser uses WebKit and AR Quick Look works from any
 * of them, but we still require AppleWebKit to avoid spoofed user agents.
 */
export function isIosAr(
  userAgent: string = navigator.userAgent,
  win: Window | undefined = typeof window === "undefined" ? undefined : window,
): boolean {
  const isIosDevice = /iPad|iPhone|iPod/.test(userAgent);
  if (!isIosDevice) return false;
  if (win && "MSStream" in win) return false;
  return /AppleWebKit/.test(userAgent);
}
